// extracted by mini-css-extract-plugin
export default {"search_wrapper":"SearchBar_search_wrapper__RDeta"};